module.exports = __webpack_public_path__ + "static/media/radiantBright.efb9b1ca.gif";